import CoreAPI from '../Core/CoreAPI';
import { getSessionItem } from '@services/api/src/Domains/Enviroments/EnvironmentsService';

class ClausesAPI {
  constructor() {
    this.setApi(new CoreAPI(getSessionItem('API_CLAUSES')));
  }

  setApi(api) {
    this.api = api;
  }

  getAPI() {
    if (!this.api.baseURL) this.setApi(new CoreAPI(getSessionItem('API_CLAUSES')));

    return this.api;
  }

  async returnedModality(id) {
    const { data } = await this.api
      .getInstance()
      .get(`modalities/insuredType/${id}`);
    return data;
  }

  async showClause(insuredType, modalityId, subModalityId) {
    const { data } = await this.getAPI()
      .getInstance()
      .get(
        `contractClauses/all?insuredType=${insuredType}&modalityId=${modalityId}&subModalityId=${subModalityId}`
      );

    return data;
  }
  async downloadClause(clauseType, clauseId) {
    return this.getAPI()
      .getInstance()
      .get(`contractClauses/downloadClause/${clauseType}/${clauseId}`, {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/pdf'
        }
      });
  }
}

const api = new ClausesAPI();
export default api;
